module.exports = __webpack_public_path__ + "static/media/b-sci-major-40_LR.a10e5f60.jpg";